import { tgUserLanguage } from '@/components/tg/user'

const DEFAULT_LANGUAGE = 'en'

// Telegram webviews and Safari private mode can throw on any localStorage
// access. The chosen language must survive that for the session, so this
// module owns an in-memory copy and treats storage as best effort.
let sessionLanguage: string | null = null

export function getUserLanguage(): string {
    if (sessionLanguage) return sessionLanguage
    try {
        return localStorage.getItem(tgUserLanguage) || DEFAULT_LANGUAGE
    } catch {
        return DEFAULT_LANGUAGE
    }
}

export function setUserLanguage(language: string): void {
    const next = language || DEFAULT_LANGUAGE
    sessionLanguage = next
    try {
        localStorage.setItem(tgUserLanguage, next)
    } catch (error) {
        console.error('Failed to persist language selection:', error)
    }
}

/** Languages the app ships translations for (options `onboarding.language`). */
export const SUPPORTED_LANGUAGES = ['en', 'es', 'ar', 'hi', 'ru']

/** The language the user already picked this or an earlier session, if any. */
export function getStoredUserLanguage(): string | null {
    if (sessionLanguage) return sessionLanguage
    try {
        return localStorage.getItem(tgUserLanguage)
    } catch {
        return null
    }
}

/**
 * First-run language without asking: the Telegram client language when the
 * app is translated into it, English otherwise. Telegram reports codes like
 * `en_us` or `pt-BR`, so only the primary subtag is compared.
 */
export function resolveInitialLanguage(
    telegramCode?: string,
    supported: string[] = SUPPORTED_LANGUAGES
): string {
    const primary = (telegramCode || '').toLowerCase().split(/[-_]/)[0]
    return supported.includes(primary) ? primary : DEFAULT_LANGUAGE
}

/** Test-only: forget the in-memory language so storage is read again. */
export function resetSessionLanguageForTests(): void {
    sessionLanguage = null
}
